export const getAdmisionDegree = (state = [], action) => {
  switch (action.type) {
    case "GET_ADDMSN_DEGREE":
      return action.payload.data;
    default:
      return state;
  }
};
